export const isVariantOption = (
  value: unknown
): value is { variant_id: string; variant_url: unknown } =>
  typeof value === 'object' &&
  value !== null &&
  typeof (value as { variant_id?: unknown }).variant_id === 'string';
